/* eslint-disable no-underscore-dangle */
/**
 * @createdBy:HuangJian
 * @date:2019/1/10
 * @description：单列表页面的高度计算混入
 */
import {getScrollBarHeight} from '@/utils/scrollbar';
import {getStyle} from '@/utils/linktools';

export default {
    provide: {resizeHandler: this},
    props: {
        /* 自动适应高度，用于单列表页面 */
        fitHeight: Boolean,
        minOffsetTop: {
            type: Number,
            default(){
                return 56;
            }
        }
    },
    data(){
        return {
            isHeightFited: false,
            /* 表格的最终高度*/
            tableFitHeight: 0,
            /* 是否有横向滚动条 */
            horizonScroll: false,
            /* 表格组件引用 */
            tableInstance: null,
            /* tab页实例*/
            tabInstance: null,
            /* pager实例*/
            pagerInstance: null,
            /* 响应窗口大小变化*/
            resizeChoke: false
        };
    },
    computed: {
        scrollBarHeight(){
            return getScrollBarHeight();
        },
        tableAvailHeight(){
            var rslt = this.tableFitHeight;
            const headerHeight = this.tableHeaderHeight || 40;
            rslt -= headerHeight;
            if(this.isTableHorizonScroll()){
                rslt -= this.scrollBarHeight;
            }
            return rslt<0?0:rslt;
        },
        /* 表格表头高度 */
        tableHeaderHeight(){
            var result = null;
            if(this.tableInstance){
                result = this.tableInstance.layout.headerHeight;
            }
            return result;
        }
    },
    methods: {
        /**
         * @method：initInstace
         * @createdBy:HuangJian
         * @date:2019/3/12
         * @params：
         * @description：初始化
         */
        initInstace(){
            this.tableInstance = this.$getChildComponent('el-table');
            this.pagerInstance = this.$getChildComponent('lnk-pagination-v');
            this.tabInstance = this.$getParentComponent('pl-navigator-main-page');
        },
        /**
         * @method：getMainviewHeight
         * @createdBy:HuangJian
         * @date:2019/1/10
         * @params：
         * @description：获取路由页面的高度
         */
        getMainviewHeight(){
            var rslt = null;
            const el = (this.tabInstance || {}).$el;
            if(el) {
                rslt = el.offsetHeight;
            }
            return rslt;
        },
        /**
         * @method：getMainviewBottomGap
         * @createdBy:HuangJian
         * @date:2019/1/14
         * @params：
         * @description：获取路由页面底部的边距
         */
        getMainviewBottomGap(){
            var rslt = 16;
            const tab = (this.tabInstance || {}).$el;
            const el = tab && tab.querySelector('.pl-navigator-main-page-item');
            if(el){
                rslt = getStyle(el, 'marginBottom', true) || 0;
                rslt += getStyle(el, 'paddingBottom', true) || 0;
            }
            return rslt;
        },
        /**
         * @method：getPagerHeight
         * @createdBy:HuangJian
         * @date:2019/1/14
         * @params：
         * @description：获取分页栏及边距占的高度
         */
        getPagerHeight(){
            var rslt = 36;
            const pager = (this.pagerInstance || {}).$el;
            if(pager){
                rslt = pager.offsetHeight;
                rslt += getStyle(pager, 'marginTop', true) || 0;
                rslt += getStyle(pager, 'marginBottom', true) || 0;
            }
            return rslt;
        },
        /**
         * @method：getTableOffsetTop
         * @createdBy:HuangJian
         * @date:2019/1/10
         * @params：
         * @description：获取表格相对于顶部的位置
         */
        getTableOffsetTop(){
            var rslt = null;
            var table = (this.tableInstance || {}).$el;
            if(table && table.offsetParent){
                rslt = table.offsetTop - 0;
            }else {
                rslt = this.minOffsetTop;
            }
            return rslt;
        },
        /**
         * @method：isTableHorizonScroll
         * @createdBy:HuangJian
         * @date:2019/1/11
         * @params：
         * @description：是否有横向滚动条
         */
        isTableHorizonScroll(){
            var rslt =null;
            if(this.tableInstance){
                rslt = Boolean(this.tableInstance.layout.scrollX);
            }
            this.$nextTick(() => {
                this.horizonScroll = rslt;
            });
            return rslt;
        },
        /**
         * @method：getTableAvailableHeight
         * @createdBy:HuangJian
         * @date:2019/1/10
         * @params：
         * offsetTop：表格相对于父元素顶部的高度
         * @description：获取表格能利用的最大高度
         */
        getTableAvailableHeight(offsetTop){
            var rslt = this.getMainviewHeight();
            rslt -= this.getPagerHeight();
            rslt -= this.getMainviewBottomGap();
            rslt -= offsetTop;
            return rslt<0?0:rslt;
        },
        /**
         * @method：renderValidHeight
         * @createdBy:HuangJian
         * @date:2019/1/10
         * @params：
         * @description：根据有效的offset值获取高度
         */
        renderValidHeight(){
            const offsetTop = this.getTableOffsetTop();
            if(offsetTop!==null && offsetTop>=this.minOffsetTop){
                this.$nextTick(() => {
                    this.tableFitHeight = this.getTableAvailableHeight(offsetTop);
                    this.$emit('resized');
                });
            }else {
                setTimeout(this.renderValidHeight, 10);
            }
        },
        /**
         * @method：fitableHeigt
         * @createdBy:HuangJian
         * @date:2019/3/12
         * @params：
         * @description：
         */
        fitTableHeigt(){
            this.initInstace();
            const el = (this.tabInstance || {}).$el;
            if(el){
                const display = getStyle(el, 'display');
                if(display==='none') {
                    this.resizeChoke = true;
                    return;
                }
                this.resizeChoke = false;
                this.renderValidHeight();
            }
        },
        /**
         * @method：onOpenTab
         * @createdBy:HuangJian
         * @date:2019/3/12
         * @params：
         * @description：监听tab的切换
         */
        onOpenTab(){
            if(this.resizeChoke){
                this.$nextTick(this.fitTableHeigt);
            }
        }
    },
    created(){
        if(this.fitHeight){
            this.$on('resize', this.fitTableHeigt);
            const maintab =this.$getParentComponent('pl-navigator-main');
            if(maintab){
                maintab.$on('openTab', this.onOpenTab);
            }
        }
    },
    mounted() {
        this.initInstace();
        this.isTableHorizonScroll();
        if(this.fitHeight){
            this.fitTableHeigt();
            window.addEventListener('resize', this.fitTableHeigt);
        }

    },
    beforeDestory(){
        if(this.fitHeight) {
            this.$off('resize');
            const maintab =this.$getParentComponent('pl-navigator-main');
            if(maintab){
                maintab.$off('openTab', this.fitTableHeigt);
            }
            window.removeEventListener('resize', this.onOpenTab);
        }
    }
};
